import * as React from 'react'
import * as MarkdownIt from 'markdown-it'
import styled from "styled-components"
import Container from '../components/container'
import { ContentfulClientApi } from 'contentful';
import WithContentful from '../high-order/with-contentful'


interface FooterData {
    body:string
}

interface Props{
    client:ContentfulClientApi
}


export default WithContentful( class extends React.Component<Props, { data:FooterData }>{


    componentDidMount(){
        const cached = window.sessionStorage.getItem("isaver-footer")
        if(cached){
            console.log("Load footer from cached session state. Open in new tab to see updates")
            const state = JSON.parse(cached)
            this.setState(state)
        }else{
            this.props.client.getEntries({
                content_type: "footer"
            }).then(response => {
                console.log("FOOTER");
                console.log(response)
                const state = {
                    data: response.items[0].fields
                }
                window.sessionStorage.setItem("isaver-footer", JSON.stringify(state))
                this.setState(state)
            })
        }
    }



    render(){
        if(!this.state) return null;
        const data = this.state.data;
        
        return (
            <FooterContainer>
                <Container>
                    <div dangerouslySetInnerHTML={this.createMarkup( data.body )}></div>
                </Container>
            </FooterContainer>
        )
    }

        
    createMarkup(html:string){
        var md = new MarkdownIt({
            html: true,
            linkify: true,
        });

        return {
            __html: md.render( html )
        }
    }
   
})



const FooterContainer = styled.div`
    width: 100%;
    color: white;
    background-color:#FF6900;
    padding-top: 30px;
    padding-bottom: 30px;
    text-align: center;
    border-top: 1px solid rgba(0,0,0,0.15);

    a{
        color: #FFF !important;
        font-weight: 700;

        :hover, :focus, :active{
            opacity: 0.8 !important;
            text-decortation: none !important;
        }

    }

`





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/components/footer.tsx